import { CdkAccordionModule } from '@angular/cdk/accordion';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { CoreModule } from '@appCore/core.module';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

@NgModule({
    declarations: [AppComponent],
    imports: [CoreModule, AppRoutingModule, BrowserAnimationsModule, CdkAccordionModule, BrowserModule],
    providers: [],
    bootstrap: [AppComponent]
})
export class AppModule {}
